import {
  Component,
  AfterViewInit,
  ElementRef,
  OnInit,
  computed,
  ViewChild,
  effect,
} from "@angular/core";
import { AvatarModule } from "primeng/avatar";
import { AvatarGroupModule } from "primeng/avatargroup";
import { ButtonModule } from "primeng/button";
import { CardModule } from "primeng/card";
import { DrawerModule } from "primeng/drawer";
import { InputIconModule } from "primeng/inputicon";
import { InputTextModule } from "primeng/inputtext";
import { TableModule } from "primeng/table";
import { ToggleButtonModule } from "primeng/togglebutton";
import { HeaderService } from "../../core/services/header.service";
import { HeaderTagsComponent } from "../../shared/components/header-tags/header-tags.component";
import { MsalApiService } from "../../core/services/msal-api.service";
import { DomSanitizer, SafeUrl } from "@angular/platform-browser";
import { MsalService } from "@azure/msal-angular";
import { AccountInfoDto } from "../../core/models/account-info-msal.dto";
import { InputGroupModule } from "primeng/inputgroup";
import { InputGroupAddonModule } from "primeng/inputgroupaddon";
import { CommonModule } from "@angular/common";
import { SharedService } from "../../core/services/shared.service";
import { PublicClientApplication } from "@azure/msal-browser";
import { NavigationEnd, Router } from "@angular/router";
import { filter } from "rxjs/operators";
import { UserMobileAppQrCodeShowHide } from "../../core/models/common/userMobileAppQrCodeShowHide";
import { Popover, PopoverModule } from "primeng/popover";
import { UserManagementService } from "../../core/services/user-management.service";
import { GenericResponseDto } from "../../core/models/generic-response.dto";
import { ValidateLogin } from "../../core/models/validate-login.dto";
import { MenuModule } from "primeng/menu";
import { MenuItem } from "primeng/api";
import { NotificationsDto } from "../../core/models/common/notification.dto";
import { JniToastrService } from "../../core/services/jni-toastr.service";
import { NameInitialsPipe } from "../../shared/pipes/name-initials/name-initials.pipe";
import { SignalRService } from "../../core/services/signal-r.service";
import { OverlayBadgeModule } from "primeng/overlaybadge";
import { DialogModule } from "primeng/dialog";
import { SpinnerComponent } from "../../shared/components/spinner/spinner.component";
import { FormsModule } from "@angular/forms";
import { LoaderService } from "../../core/services/loader.service";
import { SelectModule } from "primeng/select";

@Component({
  selector: "jni-header",
  imports: [
    DrawerModule,
    ButtonModule,
    CommonModule,
    FormsModule,
    InputIconModule,
    InputTextModule,
    AvatarModule,
    AvatarGroupModule,
    ToggleButtonModule,
    CardModule,
    TableModule,
    HeaderTagsComponent,
    InputGroupModule,
    InputGroupAddonModule,
    SelectModule,
    PopoverModule,
    ButtonModule,
    MenuModule,
    NameInitialsPipe,
    OverlayBadgeModule,
    DialogModule,
    SpinnerComponent,
  ],
  standalone: true,
  templateUrl: "./header.component.html",
  styleUrl: "./header.component.scss",
})
export class HeaderComponent implements AfterViewInit, OnInit {
  profileImage = "";
  user!: AccountInfoDto;
  showHeaderTags = computed(() => this.headerService.showHeaderTags$());
  showMobileAppQrCodeNotification = true;
  menuItems: MenuItem[] | undefined = [];
  displayMobilePopUp = "";
  userData!: ValidateLogin;
  showNotifications = false;
  notificationList = [] as NotificationsDto[];
  notificationCount = 0;
  notificationHistoryList = [] as NotificationsDto[];
  notificationHistoryDialog = false;
  showNotificataionSmallLoader = false;
  simpleOrderSearchResponse: string[] = [];
  searchedText = "";
  searchScope = "orders";
  // searchScopeOptions = [
  //   { label: "Orders", value: "orders" },
  //   { label: "Task Manager", value: "tasks" },
  // ];
  @ViewChild("opMobileApp") overlay!: Popover;
  @ViewChild("actualTarget") anchor!: ElementRef<HTMLAnchorElement>;
  @ViewChild("displayButton") button!: ElementRef<HTMLButtonElement>;

  constructor(
    private headerService: HeaderService,
    private el: ElementRef,
    private msalApisService: MsalApiService,
    private domSanitizer: DomSanitizer,
    private authService: MsalService,
    private sharedService: SharedService,
    private _loginService: UserManagementService,
    private _router: Router,
    private _sharedService: SharedService,
    private _toastrService: JniToastrService,
    private router: Router,
    private _signalRService: SignalRService,
    private _loaderService: LoaderService
  ) {
    effect(() => {
      const x = this._signalRService.notifications();
      if (x && x.chatId && x.moduleName && x.chatId !== 0) {
        this.getNotificationsList(x.chatId, false, x.moduleName);
      } else {
        this.getNotificationsList(0, false, "");
      }
    });
  }

  ngAfterViewInit() {
    const height = this.el.nativeElement.offsetHeight; // Get header height
    this.headerService.setHeaderHeight(height); // Pass height to service
    this.initializeMenuItems();
  }

  ngOnInit(): void {
    this.getUserDetails();
    this.validateLoginAndgetUserProfile();
    this.syncSearchScopeWithRoute();
  }

  private syncSearchScopeWithRoute() {
    // Set initial scope based on current URL
    if (this.router.url.startsWith("/task-management")) {
      this.searchScope = "tasks";
    }
    // Update scope on navigation
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        if (event.urlAfterRedirects.startsWith("/task-management")) {
          this.searchScope = "tasks";
        } else {
          this.searchScope = "orders";
        }
      });
  }

  isDarkTheme(): boolean {
    return localStorage.getItem("theme") === "dark";
  }

  toggleDarkMode() {
    const element = document.querySelector("html");
    if (!element) return;
    const isDark = element.classList.toggle("my-app-dark");
    localStorage.setItem("theme", isDark ? "dark" : "light");
    this.sharedService.setTheme(isDark ? "dark" : "light");
  }

  getUserDetails(): void {
    const msalInstance = this.authService
      .instance as unknown as PublicClientApplication;
    const accounts = msalInstance.getAllAccounts();
    if (accounts.length > 0) {
      this.user = accounts[0];
      this.fetchUserProfile();
    }
  }

  fetchUserProfile(): void {
    this.msalApisService.getADUserProfilePicture().subscribe({
      next: (res: Blob) => {
        const urlCreator = window.URL || window.webkitURL;
        const safeUrl: SafeUrl = this.domSanitizer.bypassSecurityTrustUrl(
          urlCreator.createObjectURL(res)
        );
        this.profileImage = this.domSanitizer.sanitize(4, safeUrl) ?? "";
      },
      error: () => {
        this.profileImage = "../../../assets/images/avatar-default.webp";
      },
    });
  }

  redirectToSalesAppPage() {
    this._router.navigate(["/download-mobile-app"]);
  }

  setHideMobilePopupDisplayValue() {
    // localStorage.setItem('MobilePopUpDisplay', 'false');
    // if (this.overlay) {
    //   this.overlay.hide();
    // }

    const obj: UserMobileAppQrCodeShowHide = {
      showMobileAppQrCodeNotification: false,
    };

    this.overlay.hide();
    this._loginService
      .userMobileAppQrCodeShowHide(obj)
      .pipe()
      .subscribe((res: GenericResponseDto<boolean>) => {
        if (res?.data) {
          // TODO list
        }
      });
  }

  checkMobilePopUpDisplayValue() {
    //const check = localStorage.getItem('MobilePopUpDisplay');
    if (this.showMobileAppQrCodeNotification === true) {
      if (this.overlay && this.anchor && this.button) {
        this.button.nativeElement.click();
      }
    }
  }

  validateLoginAndgetUserProfile() {
    this._loginService
      .validateLogin()
      .pipe()
      .subscribe((res: GenericResponseDto<ValidateLogin>) => {
        if (res?.data) {
          this.showMobileAppQrCodeNotification =
            res.data.showMobileAppQrCodeNotification;
          this.checkMobilePopUpDisplayValue();
          this.userData = res?.data;
        }
      });
  }

  navigateToProfile() {
    this._router.navigate(["/profile/" + this.userData?.userId]);
  }

  dashboardLayout() {
    this._router.navigate(["/dashboard/dashboard-setting"]);
  }

  logoutHandler() {
    this.authService.logoutRedirect({
      postLogoutRedirectUri: "/",
    });
    const status = localStorage.getItem("theme");
    this.displayMobilePopUp = this.sharedService.getDisplayMobilePopUpValue();
    localStorage.clear();
    localStorage.setItem("theme", status ?? "");
    localStorage.setItem("MobilePopUpDisplay", this.displayMobilePopUp);
  }

  initializeMenuItems() {
    this.menuItems = [
      {
        label: "Profile",
        icon: "pi pi-user",
        command: () => {
          this.navigateToProfile();
        },
      },
      {
        label: "Dashboard Settings",
        icon: "pi pi-cog",
        command: () => {
          this.dashboardLayout();
        },
      },
      {
        label: "Logout",
        icon: "pi pi-sign-out",
        command: () => {
          this.logoutHandler();
        },
      },
    ];
  }
  isShowNotifications(notificationPopover: Popover) {
    notificationPopover.toggle(!this.showNotifications);
    this.showNotifications = !this.showNotifications;
  }

  getNotificationsList(
    chatId = 0,
    getAll = false,
    moduleName = "ProductionWorkflow"
  ) {
    this._sharedService.getNotifications(chatId, getAll, moduleName).subscribe({
      next: res => {
        if (res?.data) {
          if (res?.data.length > 0) {
            if (getAll && this.notificationHistoryDialog) {
              this.showNotificataionSmallLoader = false;
              this.notificationHistoryList = res?.data;
            } else {
              const filterList = res?.data.filter(obj => {
                const exist = this.notificationList.find(
                  x => x.notificationId === obj.notificationId
                );
                if (exist) {
                  return false;
                } else {
                  return true;
                }
              });
              if (chatId !== 0 && filterList.length !== 0) {
                this.notificationList.unshift(
                  filterList[filterList.length - 1]
                );
              } else {
                this.notificationList.push(...filterList);
              }
              this.notificationCount = this.notificationList.length;
              if (filterList.length > 0 && moduleName !== "") {
                this._toastrService.info(
                  "Notification",
                  "You have received a New Notification"
                );
              }
            }
          }
        }
      },
      error: () => {
        if (getAll) {
          this.showNotificataionSmallLoader = false;
        }
        this._toastrService.error("Error", "Failed to get Notifications");
      },
    });
  }

  getPaddedTaskId(taskId: string) {
    return taskId.padStart(6, "0");
  }

  showNotificationHistoryPopUp() {
    this.notificationHistoryDialog = !this.notificationHistoryDialog;
    this.notificationHistoryList = [];
    this.showNotificataionSmallLoader = true;
    this.getNotificationsList(0, true);
  }

  getNotificationProjectDetails(notificationId: number) {
    this.showNotificataionSmallLoader = true;
    this._sharedService
      .getNotificationProjectDetails(notificationId)
      .subscribe({
        next: res => {
          this.showNotificataionSmallLoader = false;
          if (res?.data && res?.data !== "") {
            this.notificationHistoryDialog = false;
            const data = JSON.parse(res?.data);
            this.redirectToWorkflowSummary(data[0], data[1]);
          } else {
            this._toastrService.error("Error", res.message);
          }
        },
        error: () => {
          this.showNotificataionSmallLoader = false;
          this._toastrService.error("Error", "No Records Found");
        },
      });
  }

  redirecttoTaskSummary(taskId: string) {
    if (taskId !== "0") {
      const url = this.router.serializeUrl(
        this.router.createUrlTree([`/task-management/task-detail/${taskId}`])
      );
      window.open(url, "_blank");
    }
  }

  redirectToWorkflowSummary(workflowId: string, salesOrderId: string) {
    this.router.navigate(
      ["/project-workflow/workflow-summary/" + workflowId + "/" + salesOrderId]
      //{ queryParams: { salesOrderId: salesOrderId } }
    );
  }

  formatMessage(message: string) {
    const regex = /@<[^,]+, ([^>]+)>/g;
    return message.replace(regex, (match, p1) => `<b>@${p1}</b>`);
    //return this.sanitizer.bypassSecurityTrustHtml(message);
  }

  redirectAndMarkReadNotification(event: number) {
    const notificationItem: NotificationsDto =
      this.notificationList.find(x => x.notificationId === event) ??
      ({} as NotificationsDto);
    this._sharedService.markNotificationMarkIsRead(event).subscribe({
      next: res => {
        if (res?.status.toLocaleLowerCase() === "success") {
          this.notificationCount--;
          this.notificationList = this.notificationList.filter(
            x => x.notificationId !== event
          );
          const data = res?.data ? JSON.parse(res.data) : [];
          this._toastrService.success("Success", res?.message);
          if (notificationItem.moduleName === "TaskManagement") {
            this.redirecttoTaskSummary(notificationItem.moduleId);
          } else {
            this.redirectToWorkflowSummary(notificationItem.moduleId, data[1]);
          }
        } else {
          this._toastrService.error(
            "Error",
            "Failed to mark notification is read"
          );
        }
      },
      error: () => {
        this._toastrService.error(
          "Error",
          "Failed to mark notification is read"
        );
      },
    });
  }

  clearAndSetSimpleOrderSearchResponseObj() {
    this.simpleOrderSearchResponse = [];
    this._sharedService.setSimpleOrderSearchResponseObject(
      this.simpleOrderSearchResponse
    );
  }

  escapeXml(unsafe: string) {
    return unsafe.replace(/[<>&'"]/g, function (c: string) {
      switch (c) {
        case "<":
          return "&lt;";
        case ">":
          return "&gt;";
        case "&":
          return "&amp;";
        case "'":
          return "&apos;";
        case '"':
          return "&quot;";
        default:
          return "";
      }
    });
  }

  onSubmit() {
    // if (this.searchScope === "tasks") {
    //   if (!this.searchedText?.trim()) {
    //     this._toastrService.error("Error", "Enter keyword");
    //     return;
    //   }
    //   const searchText = this.searchedText.trim();
    //   this.searchedText = "";
    //   this._sharedService.setTaskSearchText(searchText);
    //   this.router.navigate(["/task-management"], {
    //     state: { search: searchText },
    //   });
    //   return;
    // }

    this.clearAndSetSimpleOrderSearchResponseObj();
    if (this.searchedText) {
      const tempSearchText = `"${this.searchedText}"`;
      const escapedXml = this.escapeXml(this.searchedText);
      this.searchedText = "";
      const searchedText = encodeURIComponent(`"${escapedXml}"`);
      this._loaderService.setLoaderState(true);
      this._sharedService.getSimpleOrderSearch(searchedText).subscribe({
        next: res => {
          this._loaderService.setLoaderState(false);
          this.simpleOrderSearchResponse = res.data;
          this._sharedService.setSimpleOrderSearchResponseObject(
            this.simpleOrderSearchResponse
          );
          this._sharedService.setOrderSearchValue(tempSearchText);
          this.router
            .navigateByUrl("orders/refresh-component", {
              skipLocationChange: true,
            })
            .then(() => {
              this.router.navigate(["orders"]);
            });
        },
        error: () => {
          this._loaderService.setLoaderState(false);
          this.clearAndSetSimpleOrderSearchResponseObj();
        },
      });
    } else {
      this.clearAndSetSimpleOrderSearchResponseObj();
      this._sharedService.setOrderSearchValue("");
      this.router
        .navigateByUrl("orders/refresh-component", { skipLocationChange: true })
        .then(() => {
          this.router.navigate(["orders"]);
        });
    }
  }
}
